import paginationAccessibility from './paginationAccessibility.js';

export default class facultyStaffDirectory
{
    constructor()
    {
        this.el = '#faculty-staff-directory';

        if (!$(this.el).length) {
            return;
        }

        this.data = {
            input: {
                department: '',
                accolades: '',
                jobTitles: '',
                name: '',
            },
            filterParams: {
                departments: {},
                accolades: {},
                jobTitles: {},
            },
            staffListing: '',
            pagination: {
                numPages: 0,
                currentPage: 1,
                perPage: 9,
                accessibility: null,
            },
            settings: {
                ariaMessage: '',
                previousAriaMessage: '',
            },
        };

        this._initVue();
    }

    _initVue()
    {
        let url   = $('.url-js').text();
        let facultyStaffDirectoryVueInst = new Vue({
            el: this.el,
            data: this.data,
            methods: {
                fetchFilterParams() {
                    axios.post(url + '/getFilterParams', {}).then(response => {
                        this.filterParams.departments = response.data.results.departments;
                        this.filterParams.accolades   = response.data.results.accolades;
                        this.filterParams.jobTitles   = response.data.results.jobTitles;
                    }).catch(err => {
                        console.error(err);
                    });
                },

                fetchListing() {
                    this.settings.previousAriaMessage = this.settings.ariaMessage;
                    this.settings.ariaMessage = '';

                    axios.post(url + '/getListing', {
                        perPage:     this.pagination.perPage,
                        currentPage: this.pagination.currentPage,
                        filterItems: this.input,
                    }).then(response => {
                        this.staffListing           = response.data.results.results;
                        this.pagination.numPages    = response.data.results.totalPages;
                        this.pagination.currentPage = response.data.results.currentPage;
                        this.pagination.accessibility.setAriaLabels();

                        let results = this.staffListing.length === 1 ? 'result' : 'results';
                        if (this.settings.previousAriaMessage === this.staffListing.length + ' ' + results + ' returned') {
                            this.settings.ariaMessage = 'Returned ' + this.staffListing.length + ' ' + results;
                        } else {
                            this.settings.ariaMessage = this.staffListing.length + ' ' + results + ' returned';
                        }
                    }).catch(err => {
                        console.error(err);
                    });
                },

                pageChange() {
                    this.fetchListing();
                },
            },
            beforeMount() {
                this.pagination.accessibility = new paginationAccessibility();
                this.fetchFilterParams();
                this.fetchListing();
            },
        });
    }
}

